





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '@/models/ListingDetail';
import { ParcelHrmData } from '@/models/ParcelHrmData';

@Component
export default class HRMDataInfo extends Vue {

    @Prop(String) public readonly detailType: string | undefined;

    public buildingPermitsColumns = [
        { name: 'PermitNumber', align: 'left', label: 'Permit Number', field: 'PermitNumber', style: 'width: 40px;' },
        { name: 'DateApplication', align: 'left', label: 'Application Date', field: 'DateApplication', style: 'width: 40px;' },
        { name: 'DateIssued', align: 'left', label: 'Issued Date', field: 'DateIssued', style: 'width: 40px' },
        { name: 'ProjectDescription', align: 'left', label: 'Description', field: 'ProjectDescription', style: 'width: 40px' },
        { name: 'PermitStatus', align: 'left', label: 'Permit Status', field: 'PermitStatus', style: 'width: 40px' },
        { name: 'EstimatedValue', align: 'left', label: 'Estimated Value', field: 'EstimatedValue', style: 'width: 40px' },
        { name: 'Address', align: 'left', label: 'Address', field: 'Address', style: 'width: 60px;'},
    ];

    get parcelHrmData(): ParcelHrmData | null {
        if (this.detailType === 'listing') {
            if (this.$store.state.listings.selectedListingDetail && this.$store.state.listings.selectedListingDetail.ParcelData.ParcelHrmData.PID) {
                return this.$store.state.listings.selectedListingDetail.ParcelData.ParcelHrmData;
            }
        }
        if (this.detailType === 'parcel') {
            if (this.$store.state.parcels.selectedParcelDetail && this.$store.state.parcels.selectedParcelDetail.ParcelData.ParcelHrmData.PID) {
                return this.$store.state.parcels.selectedParcelDetail.ParcelData.ParcelHrmData;
            }
        }
        return null;
    }


    get buildingPermitsData(): string[] {
        if (this.detailType === 'listing') {
            if (this.$store.state.listings.selectedListingDetail.ParcelData.BuildPermits) {
                return this.$store.state.listings.selectedListingDetail.ParcelData.BuildPermits;
            }
        }
        if (this.detailType === 'parcel') {
            if (this.$store.state.parcels.selectedParcelDetail.ParcelData.BuildPermits) {
                return this.$store.state.parcels.selectedParcelDetail.ParcelData.BuildPermits;
            }
        }
        return [];
    }
}
